import styled from 'styled-components';

import { basic, grey } from '../../theme/colors';

export const Table = styled.table<{ dividers?: boolean }>`
  background-color: ${basic.haydenWhite};
  padding: 16px 32px;
  border-radius: 16px;

  width: 100%;
  th {
    @include typography.text--medium;
    padding: 16px 0;
  }
  td {
    @include typography.text--regular;
    color: ${grey.haydenGreyShade2};
    padding: 8px 0;
  }

  ${({ dividers }) =>
    dividers &&
    `
      td {
        padding: 16px 0;
      }

      tbody {
        tr {
          border-bottom: solid 1px ${basic.haydenBorder};
        }
        tr:last-of-type {
          border-bottom: none;
        }
      }
    `}
`;
